import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { AuthService } from '../../../shared/services/auth/auth.service';
import { ToasterService } from '../../../shared/services/toaster/toaster.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-signup-email',
  templateUrl: './signup-email.component.html',
  styleUrls: ['./signup-email.component.scss']
})
export class SignupEmailComponent implements OnInit, OnDestroy {
  loading: boolean = false;
  email: string = '';
  private SUBSCRIPTIONS: Subscription[] = [];

  constructor(
    private router: Router,
    private authService: AuthService,
    private toaster: ToasterService,
    private route: ActivatedRoute
  ) { }

  

  /**
   * Checks if the email is valid for signup and redirects to the code verification page
   */
  public async checkEmail(): Promise<void> {
    try {
      this.loading = true;

      // Guard against missing email
      if (!this.email) {
        this.toaster.warning('Please enter your email address', 4000);
        this.loading = false;
        return;
      }

      // Validate email format
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(this.email)) {
        this.toaster.warning('Please enter a valid email address', 4000);
        this.loading = false;
        return;
      }

      // Check if email is valid for signup
      console.log('Checking email for signup');
      const isValid = await this.authService.checkEmailForSignup(this.email);

      if (isValid) {
        console.log('Email is valid for signup');
        // Store email in session storage for the next step
        sessionStorage.setItem('signupEmail', this.email);
        this.router.navigate(['/auth/signup/code']);
      } else {
        console.log('Email is not valid for signup');
        this.toaster.warning('This email cannot be used for signup', 4000);
      }
    } catch (error: any) {
      console.error('Email check error:', error.message || error);
      this.toaster.warning(`Error: ${error.message || 'Failed to check email'}`, 4000);
    } finally {
      this.loading = false;
    }
  }

  ngOnInit(): void {
    this.SUBSCRIPTIONS.push(this.route.queryParams.subscribe(params => {
      if (params['email']) {
        this.email = params['email'];
      }
    }));
  }

  ngOnDestroy(): void {
    this.SUBSCRIPTIONS.forEach(subscription => subscription.unsubscribe());
  }
}
